// Configuracion global de la aplicacion

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export const STORAGE_TOKEN_KEY = 'pc_token';
export const STORAGE_USER_KEY = 'pc_user';
export const STORAGE_CART_KEY = 'pc_cart';

// Numero de WhatsApp/Yape de la tienda, en formato internacional sin "+" ni espacios.
export const CONTACT_WHATSAPP_NUMBER = '51901986801';

// Costo fijo (S/) del envio a provincia: embalaje y traslado hasta la agencia de transporte.
// Debe coincidir con Order::PROVINCE_SHIPPING_COST del backend, que es el que realmente se cobra.
export const PROVINCE_SHIPPING_COST = 10;

// Agencias de transporte sugeridas en el checkout para el envio a provincia.
export const SHIPPING_AGENCIES = ['Shalom', 'Olva Courier', 'Marvisur', 'Cruz del Sur Cargo', 'Flores'];

// Roles soportados por el backend (Laravel Sanctum)
export const ROLES = {
  CLIENTE: 'cliente',
  ADMINISTRADOR: 'administrador',
  TECNICO: 'tecnico',
  DISTRIBUIDOR: 'distribuidor',
};

export const ADMIN_ROLES = [ROLES.ADMINISTRADOR, ROLES.TECNICO];

export const PATH_AFTER_LOGIN = {
  [ROLES.CLIENTE]: '/mi-panel',
  [ROLES.ADMINISTRADOR]: '/admin',
  [ROLES.TECNICO]: '/admin',
  [ROLES.DISTRIBUIDOR]: '/distribuidor',
};
